import {
  BuscaCidadaoListagemDiabetesQuery,
  BuscaCidadaoListagemGeralQuery,
  BuscaCidadaoListagemHipertensaoQuery,
  BuscaCidadaoListagemPessoaIdosaQuery,
  BuscaCidadaoListagemSaudeBucalQuery,
  GrupoImunobiologicoEnum,
} from 'graphql/types.generated'

import { CidadaoListagemDesenvolvimentoInfantilQueryResult } from './model-desenvolvimentoInfantil'
import { CidadaoListagemGestantePuerperaQueryResult } from './model-gestantePuerpera'
import { CidadaoListagemSaudeMulherQueryResult } from './model-saudeMulher'

export type CidadaoListagemGeralQueryResult = BuscaCidadaoListagemGeralQuery['acompanhamentoCondicaoSaude']
export type CidadaoListagemGeralQueryModel = CidadaoListagemGeralQueryResult['content'][0]

export type CidadaoListagemDiabetesQueryResult = BuscaCidadaoListagemDiabetesQuery['acompanhamentoCondicaoSaude']
export type CidadaoListagemDiabetesQueryModel = CidadaoListagemDiabetesQueryResult['content'][0]

export type CidadaoListagemPessoaIdosaQueryResult = BuscaCidadaoListagemPessoaIdosaQuery['acompanhamentoCondicaoSaude']
export type CidadaoListagemPessoaIdosaQueryModel = CidadaoListagemPessoaIdosaQueryResult['content'][0]

export type CidadaoListagemHipertensaoQueryResult = BuscaCidadaoListagemHipertensaoQuery['acompanhamentoCondicaoSaude']
export type CidadaoListagemHipertensaoQueryModel = CidadaoListagemHipertensaoQueryResult['content'][0]

export type CidadaoListagemSaudeBucalQueryResult = BuscaCidadaoListagemSaudeBucalQuery['acompanhamentoCondicaoSaude']
export type CidadaoListagemSaudeBucalQueryModel = CidadaoListagemSaudeBucalQueryResult['content'][0]

export type BuscaCidadaoQueryResult =
  | CidadaoListagemGeralQueryResult
  | CidadaoListagemGestantePuerperaQueryResult
  | CidadaoListagemDesenvolvimentoInfantilQueryResult
  | CidadaoListagemDiabetesQueryResult
  | CidadaoListagemHipertensaoQueryResult
  | CidadaoListagemPessoaIdosaQueryResult
  | CidadaoListagemSaudeBucalQueryResult
  | CidadaoListagemSaudeMulherQueryResult

export type BuscaCidadaoQueryResultModel = BuscaCidadaoQueryResult['content'][0]

export const grupoImunobiologicoLabel: Record<GrupoImunobiologicoEnum, string> = {
  DIFTERIA_TETANO_PERTUSIS_HEPATITE_B_HAEMOPHILUS_INFLUENZA_B:
    'Difteria, Tétano, Pertusis, Hepatite B, Haemophilus Influenza B',
  POLIOMELITE: 'Poliomielite',
  SARAMPO_CACHUMBA_RUBEOLA: 'Sarampo, Caxumba, Rubéola',
  PNEUMOCOCICA: 'Pneumocócica',
  DTPA: 'dTpa',
  INFLUENZA: 'Influenza (últimos 12 meses)',
  HPV: 'HPV',
}
